/**
 * Carousel Image
 * https://swiperjs.com/
 */

// import Swiper from 'swiper';

import Swiper from "Vendor/swiper.js";
import $ from "jquery";

let carouselImage = undefined;

export default function carousel() {
  // When Carousel exists
  if (carousel) {
    let $obj = $(".carousel-image");

    $obj.each(function (index, element) {
      let $this = $(this);

      if (!$this.hasClass("swiper-container-horizontal")) {
        carouselImage = new Swiper(this, {
          slideToClickedSlide: true,
          slidesPerView: 2.7,
          loop: true,
          spaceBetween: 10,
          pagination: {
            el: ".swiper-pagination",
            dynamicBullets: false,
          },
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1,
          },
          navigation: {
            nextEl: ".ci-outside-swiper-button-next",
            prevEl: ".ci-outside-swiper-button-prev",
          },
          breakpoints: {
            480: {
              slidesPerView: 3.5,
            },
            640: {
              slidesPerView: 4.75,
            },
            768: {
              slidesPerView: 5.75,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      }
    });
  }
}
